import React from 'react';
const Check = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.1109 1.70424L6.33312 11.482L1.88867 7.03757" stroke={color || '#50AB35'} strokeWidth="2.37037"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default Check;
